import dayjs from 'dayjs'
import type { ComplaintOption, QuickRanges } from '../types'

export const useComplaintMeta = () => {
  const complaintStateOptions: ComplaintOption[] = [
    { label: '待处理', value: 'PENDING' },
    { label: '处理中', value: 'PROCESSING' },
    { label: '已处理', value: 'PROCESSED' },
  ]
  const refundStateOptions: ComplaintOption[] = [
    { label: '退款审批中', value: '20' },
    { label: '退款被驳回', value: '30' },
    { label: '退款失败', value: '40' },
    { label: '已退款', value: '50' },
    { label: '退款已撤回', value: '60' },
  ]
  const complaintStateMap = {
    PENDING: { label: '待处理', color: 'orange' },
    PROCESSING: { label: '处理中', color: 'blue' },
    PROCESSED: { label: '已处理', color: 'green' },
    pending: { label: '待处理', color: 'orange' },
    processing: { label: '处理中', color: 'blue' },
    finished: { label: '已处理', color: 'green' },
  }
  const refundStateMap: Record<string, { label: string; color: string }> = {
    '20': { label: '退款审批中', color: 'blue' },
    '30': { label: '退款被驳回', color: 'orange' },
    '40': { label: '退款失败', color: 'red' },
    '50': { label: '已退款', color: 'green' },
    '60': { label: '退款已撤回', color: 'orange' },
  }
  const problemTypeMap = {
    refund: { label: '申请退款', color: 'red' },
    merchant: { label: '投诉商家', color: 'blue' },
    service: { label: '服务权益未生效', color: 'green' },
  }
  const columns = [
    { title: '微信支付单号 / 投诉时间', dataIndex: 'complaintId', key: 'complaintId', width: 250 },
    { title: '问题描述', dataIndex: 'problemDescription', key: 'problemDescription', width: 140 },
    { title: '订单金额', dataIndex: 'amount', key: 'amount', width: 130 },
    { title: '投诉描述', dataIndex: 'complaintDetail', key: 'complaintDetail', width: 360 },
    { title: '被诉商户', dataIndex: 'merchantName', key: 'merchantName', width: 160 },
    { title: '被诉产品', dataIndex: 'productName', key: 'productName', width: 150 },
    { title: '投诉单状态', dataIndex: 'complaintState', key: 'complaintState', width: 120, fixed: 'right' as const },
    { title: '操作人', dataIndex: 'lastOperator', key: 'lastOperator', width: 110, fixed: 'right' as const },
    { title: '操作', dataIndex: 'action', key: 'action', width: 90, fixed: 'right' as const },
  ]
  const quickRanges: QuickRanges = {
    昨日: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
    今日: [dayjs().startOf('day'), dayjs().endOf('day')],
    上周: [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')],
    本周: [dayjs().startOf('week'), dayjs().endOf('week')],
    上月: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    本月: [dayjs().startOf('month'), dayjs().endOf('month')],
    过去7天: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')],
    过去14天: [dayjs().subtract(13, 'day').startOf('day'), dayjs().endOf('day')],
    过去30天: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')],
  }
  const refundReasons = ['未成年', '协商一致', '误操作']
  const toMoney = (value?: number | string) => Number(value || 0).toFixed(2)
  const uniqueOptions = (list: Array<string | undefined>) =>
    [...new Set(list.filter(Boolean))].map((item) => ({ label: item as string, value: item as string }))
  return {
    columns,
    quickRanges,
    refundReasons,
    toMoney,
    uniqueOptions,
    problemTypeMap,
    refundStateMap,
    complaintStateMap,
    refundStateOptions,
    complaintStateOptions,
  }
}
